import type { Customer } from "@/types";

const DEFAULT_LANGUAGE = 'da';

type CustomerLocalizationKeys = keyof Customer['localizations'][string];

export const getLocalizedCustomerValue = (
  customer: Customer | undefined | null,
  language: string = DEFAULT_LANGUAGE,
  key: CustomerLocalizationKeys
): string => {
  if (!customer) return '';
  return customer.localizations?.[language]?.[key]
    || Object.values(customer.localizations || {}).find(localization => localization[key])?.[key]
    || '';
};
